import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { OperationType } from '@app/tool/model/operationType.model';
import { PagedResponse } from '@models/response.model';

import { TableConfig } from '@app/shared/util/table-config.utils';
import { AppUtils } from '@app/shared/util/app.utils';

import { environment } from 'environments/environment';
import { map } from "rxjs/operators";

@Injectable()
export class OperationTypeService {
    static readonly OPERATION_TYPES_API_PATH = environment.baseURL + '/api/operations';

    constructor(private http: HttpClient) {
    }

    getAllOperationTypes(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<OperationType>>(OperationTypeService.OPERATION_TYPES_API_PATH, {params: params})
            .pipe(map(this.mapOperationTypes));
    }


    createOperationType(operationType: OperationType) {
        return this.http.post<OperationType>(OperationTypeService.OPERATION_TYPES_API_PATH, operationType);
    }

    updateOperationType(operationType: OperationType) {
        return this.http.put<OperationType>(`${OperationTypeService.OPERATION_TYPES_API_PATH}/${operationType.id}`, operationType);
    }

    deleteOperationType(operationType: OperationType) {
        return this.http.delete<OperationType>(`${OperationTypeService.OPERATION_TYPES_API_PATH}/${operationType.id}`);
    }

    mapOperationTypes = res => {
        return {
            operationTypes: res.items.map(operationType => new OperationType(operationType)),
            count: res.total
        };
    };

}
